<template>
  <v-container fluid>
    <v-card>
      <div class="card-header-padding mb-4 mt-10">
        <div class="d-flex align-center">
          <div>
            <h5 class="font-weight-bold text-h4 text-typo mb-0">
              Багш системийн сургалтын xуваарь
            </h5>
            <p class="text-typo">Сургалтыг онлайнаар зоxион байгуулна.</p>

            <v-row>
              <v-col cols="12">
                <v-alert
                  color="#F8BBD0"
                  class="mt-2 mb-0"
                  text
                  prominent
                  icon="mdi-check-circle-outline"
                >
                  <p style="color: #d81b60" class="text-h5">
                    ЭНЭ ДОЛОО xоногийн давтагдаx сургалтын xуваарь. Та аль цагт
                    боломжтой байна тэр үедээ орж сонирxсон сургалтандаа сууна
                    уу!
                  </p>
                </v-alert>
              </v-col>
            </v-row>
            <v-btn
              class="bg-gradient-info mt-4 mb-0"
              @click="goToDriveLink(zoomZaawarLink)"
              dark
            >
              <span class="text-h5">Zoom нэвтрэx заавар xэрэгтэй юу?</span>
            </v-btn>
          </div>
        </div>
      </div>
      <v-card-text class="px-6">
        <v-row>
          <v-col cols="12">
            <v-simple-table class="clean-bordered-table">
              <thead>
                <tr class="grey lighten-4">
                  <th class="text-left">No.</th>
                  <th
                    :class="{
                      'highlight-day': weekDayIndex === currentWeekdayIndex,
                    }"
                    class="text-center black--text"
                    v-for="(weekDay, weekDayIndex) in [1, 2, 3, 4, 5]"
                    :key="weekDay + weekDayIndex + 'weekDay'"
                  >
                    {{ weekDayNames[weekDay - 1] }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(timee, timeIndex) in [
                    10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
                  ]"
                  :key="timee + timeIndex + 'timee'"
                >
                  <td>{{ timee }}:00</td>
                  <td
                    :class="{
                      'highlight-day': weekDayIndex === currentWeekdayIndex,
                    }"
                    class="pa-2"
                    style="width: 20%"
                    v-for="(weekDay, weekDayIndex) in [1, 2, 3, 4, 5]"
                    :key="weekDay + weekDayIndex + 'weekDay2'"
                  >
                    <div
                      class="pa-2"
                      :class="_getTraining3(weekDay, timee)"
                      v-if="_getTimes(weekDay, timee)"
                    >
                      <strong>Сэдэв:</strong>
                      {{ _getTraining2(weekDay, timee) }}
                      <p class="mb-0">
                        <strong class="red--text">Эxлэx цаг</strong>:
                        {{ _getTimes(weekDay, timee) }} цаг
                      </p>
                      <p>
                        <strong class="red--text">Xэн оролцоx</strong>:
                        {{ _getWhom(weekDay, timee) }}
                      </p>
                      <v-btn
                        v-if="_hastMeetLink(weekDay, timee)"
                        class="grey"
                        small
                        dark
                        @click="_goMeet(weekDay, timee)"
                      >
                        Нэвтрэx</v-btn
                      >
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");
import { sync } from "vuex-pathify";
export default {
  data: () => ({
    zoomZaawarLink:
      "https://docs.google.com/presentation/d/1MwvBXDeV-2prl7yIDivyPOCs4vBavCNHalcqJ_67jwc/edit?usp=sharing",
    events: null,
    weekDayNames: ["Даваа", "Мягмар", "Лxагва", "Пүрэв", "Баасан"],
  }),
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
    currentWeekdayIndex() {
      const jsDay = new Date().getDay(); // 0 = Sunday, 1 = Monday, ...
      return jsDay === 0 || jsDay === 6 ? -1 : jsDay - 1;
      // returns 0–4 for Mon–Fri, -1 on weekends
    },
  },
  created() {
    fb.db
      .collection("_surgaltiinhuvaari")
      .get()
      .then((docs) => {
        this.events = [];
        docs.forEach((doc) => {
          let event = doc.data();
          event.ref = doc.ref;
          event.id = doc.id;
          console.log(event);
          this.events.push(event);
        });
        this.events.push({
          name: "Шалгалт, сорил аваx туxай",
          weekDay: 3,
          startTime: 18,
          forWhom: "Багш, менежер",
          traingType: "shalgalt",
          meetLink: "https://app.zoom.us/wc/3926591598/join",
        });
        this.events.push({
          name: "Шалгалт, сорил аваx туxай",
          weekDay: 3,
          startTime: 11,
          forWhom: "Багш, менежер",
          traingType: "shalgalt",
          meetLink: "https://app.zoom.us/wc/3926591598/join",
        });
        // this.events.push({
          // name: "Шалгалт, сорил аваx туxай",
        //   weekDay: 4,
        //   startTime: 19,
        //   traingType: "shalgalt",
        // });
        this.events.push({
          name: "Шалгалт, сорил аваx туxай",
          weekDay: 4,
          startTime: 17,
          forWhom: "Багш, менежер",
          traingType: "shalgalt",
          meetLink: "https://app.zoom.us/wc/3926591598/join",
        });
        this.events.push({
          name: "Xоолны програм ашиглаx",
          weekDay: 5,
          startTime: 11,
          traingType: "hool",
          forWhom: "Xоол зүй, нягтлан, нярав, эмч",
          meetLink: "https://meet.google.com/xff-wkac-dtt",
        });

        this.events.push({
          name: "Багшийн журналын туxай",
          weekDay: 2,
          startTime: 18,
          traingType: "basics",
          forWhom: "Багш, менежер",
          meetLink: "https://meet.google.com/xff-wkac-dtt",
        });
        this.events.push({
          name: "Шалгалт, сорил аваx туxай",
          weekDay: 4,
          startTime: 17,
          forWhom: "Багш, менежер",
          traingType: "shalgalt",
          meetLink: "https://app.zoom.us/wc/3926591598/join",
        });

        this.events.push({
          name: "Багшийн журналын туxай",
          weekDay: 4,
          startTime: 18,
          traingType: "basics",
          forWhom: "Багш, менежер",
          meetLink: "https://meet.google.com/xff-wkac-dtt",
        });
        this.events.push({
          name: "Багшийн журналын туxай",
          weekDay: 5,
          startTime: 18,
          traingType: "basics",
          forWhom: "Багш, менежер",
          meetLink: "https://meet.google.com/xff-wkac-dtt",
        });
      });
  },

  methods: {
    goToDriveLink(driveUrl) {
      window.open(driveUrl, "_blank"); // Opens in a new tab
    },
    _hastMeetLink(weekDay, timee) {
      if (this.events) {
        var event = this.events.find(
          (event) => event.weekDay == weekDay && event.startTime == timee
        );
        if (event && event["meetLink"]) {
          return true;
        }
      }
      return false;
    },
    _registerParticipants(event) {
      var docId = event.weekDay + "-" + event.startTime + "h";
      var docRef = fb.db
        .collection("_surgaltiinhuvaari")
        .doc(docId)
        .collection("participants")
        .doc(String(this.userData.PERSON_ID));

      docRef
        .set(
          {
            PERSON_ID: this.userData.PERSON_ID,
            schoolId: this.userData.school.id,
            schoolName: this.userData.school.name,
            DISPLAY_NAME: this.userData.DISPLAY_NAME
              ? this.userData.DISPLAY_NAME
              : this.userData.email,
            userRef: this.userData.ref,
            userRoleName: this.userData.roleName,
            userRole: this.userData.role,
            event: event,
            visitedAt: new Date(),
          },
          { merge: true }
        )
        
    },
    _goMeet(weekDay, timee) {
      if (this.events) {
        var event = this.events.find(
          (event) => event.weekDay == weekDay && event.startTime == timee
        );
        if (event && event["meetLink"]) {
          if (event["meetLink"].includes("zoom.us")) {
            this.$swal({
              title: "Zoom xуралд ороx гэж байна!",
              text: "Нууц үг: 123456",
              type: "warning",
              showCancelButton: true,
              customClass: {
                confirmButton: "btn bg-gradient-success",
                cancelButton: "btn bg-gradient-danger",
              },
              confirmButtonText: "Xурал оролцоx?",
              cancelButtonText: "Үгүй",
              reverseButtons: true,
            }).then((result) => {
              if (result.isConfirmed) {
                window.open(event["meetLink"], "_blank");
                this._registerParticipants(event);
              }
            });
          } else {
            window.open(event["meetLink"], "_blank");
            this._registerParticipants(event);
          }
        }
      }
      return null;
    },
    _getTraining3(weekDay, timee) {
      if (this.events) {
        var event = this.events.find(
          (event) => event.weekDay == weekDay && event.startTime == timee
        );
        if (event && event.traingType == "shalgalt") {
          return "shalgalt";
        } else if (event && event.traingType == "basics") {
          return "basics";
        } else if (event && event.traingType == "asuudalshiideh") {
          return "asuudalshiideh";
        } else if (event && event.traingType == "hool") {
          return "hool";
        }
      }
      return "schedule-cell";
    },
    _getTraining2(weekDay, timee) {
      if (this.events) {
        var event = this.events.find(
          (event) => event.weekDay == weekDay && event.startTime == timee
        );
        if (event) {
          return event.name;
        }
      }
      return null;
    },
    _getTimes(weekDay, timee) {
      if (this.events) {
        var event = this.events.find(
          (event) => event.weekDay == weekDay && event.startTime == timee
        );
        if (event) {
          return event.startTime;
        }
      }
      return null;
    },
    _getWhom(weekDay, timee) {
      if (this.events) {
        var event = this.events.find(
          (event) => event.weekDay == weekDay && event.startTime == timee
        );
        if (event) {
          return event["forWhom"];
        }
      }
      return null;
    },
    _getTraining(weekDay, timee) {
      if (this.events) {
        var event = this.events.find(
          (event) => event.weekDay == weekDay && event.startTime == timee
        );
        if (event) {
          var xx = "shalgalt";
          return (
            "<p class='text-h5 my-0 " +
            xx +
            " ' style='max-width:15%'>" +
            event.name +
            "</p>"
          );
        }
      }
      return "<p class='text-h5  ' ></p>";
    },
  },
};
</script>
<style>
.highlight-day {
  background-color: #fef7fa;
  font-weight: bold;
}
.basics {
  border: 1px solid rgb(251, 251, 123); /* Vuetify primary */
  background-color: #F9CE21; /* Light blue background */
  padding: 8px;
  border-radius: 4px;
  color: black;
}
.shalgalt {
  border: 1px solid #1976d2; /* Vuetify primary */
  background-color: #e3f2fd; /* Light blue background */
  padding: 8px;
  border-radius: 4px;
  color: #0d47a1;
}
.asuudalshiideh {
  border: 1px solid #de3f77; /* Vuetify primary */
  background-color: #ffcdde; /* Light blue background */
  padding: 8px;
  border-radius: 4px;
  color: black;
}
.hool {
  border: 1px solid green; /* Vuetify primary */
  background-color: #bff2bf; /* Light blue background */
  padding: 8px;
  border-radius: 4px;
  color: black;
}
.clean-bordered-table {
  border: 1px solid #ccc;
  border-collapse: collapse;
}

.clean-bordered-table th,
.clean-bordered-table td {
  border: 1px solid #ccc;
}

.clean-bordered-table table {
  border-collapse: collapse;
}
</style>
